import { useEffect } from 'react';
import BibleUpload from './BibleUpload';

interface BibleUploadModalProps {
  onClose: () => void;
}

export default function BibleUploadModal({ onClose }: BibleUploadModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors text-2xl font-light leading-none"
        >
          ✕
        </button>

        <div className="p-6 pt-12">
          <h2 className="text-xl font-bold text-bible-dark mb-1">Upload Bible</h2>
          <p className="text-sm text-gray-600 mb-4">Import Bible content from XML file</p>

          <BibleUpload onSuccess={onClose} />
        </div>
      </div>
    </div>
  );
}
